// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__28S8s","label":"Radio_label__2s3Yu","checkMark":"Radio_checkMark__1YxfT","disabled":"Radio_disabled__21IOt"};